<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-nowrap">
            <input-header title="Name" />
            <text-field
                v-model="localValue.name"
                :is-loading="isLoading"
                autocomplete="off"
                placeholder="Studiengangname"
                class="border border-primary border-opacity-100"
            />
        </div>

        <div class="d-flex flex-nowrap">
            <input-header title="Kurzname" />
            <text-field
                v-model="localValue.kurzName"
                :is-loading="isLoading"
                placeholder="Kurzname"
                class="border border-primary border-opacity-100"
            />
        </div>

        <div v-if="availableFachbereiche?.length > 0" class="d-flex flex-nowrap">
            <input-header title="Fachbereich" />
            <common-select-field-single
                v-model="localValue.fachbereich"
                :items="availableFachbereiche"
            />
        </div>

        <div class="d-flex flex-nowrap">
            <input-header title="Standort" />
            <v-combobox
                v-model="localValue.standort"
                class="standort-combobox border border-primary border-opacity-100"
                :items="availableStandorte"
                density="default"
                hide-details
                variant="solo"
                :loading="isLoading"
                placeholder="Standort auswählen"
            />
        </div>

        <div class="d-flex flex-nowrap">
            <input-header title="Abschlussart" />
            <common-select-field-single
                v-model="localValue.abschlussArt.abschluss"
                :items="availableAbschlussArten"
                item-title="abschluss"
                item-value="abschluss"
            />
        </div>

        <div class="d-flex flex-nowrap studienformen-row">
            <input-header title="Studienformen" class="studienformen-header" />
            <v-combobox
                v-model="localValue.studienformen.studienformen"
                class="studienformen-combobox border border-primary border-opacity-100"
                :items="availableStudienformen"
                item-title="name"
                density="default"
                return-object
                multiple
                chips
                hide-details
                variant="solo"
                :loading="isLoading"
                placeholder="Studienformen auswählen"
            />
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import InputHeader from '@/js/components/Common/InputHeader.vue'
    import { TextField } from '@/js/components/Common'

    const props = defineProps({
        modelValue: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        availableStudienformen: {
            type: Array,
            required: true
        },
        availableAbschlussArten: {
            type: Array,
            required: true
        },
        availableStandorte: {
            type: Array,
            required: true
        },
        availableFachbereiche: {
            type: Array,
            required: false,
            default: () => []
        }
    })

    const emit = defineEmits(['update:modelValue'])

    const localValue = computed({
        get: () => props.modelValue,
        set: (value) => emit('update:modelValue', value)
    })
</script>
